import { create } from 'zustand'

import ApiClient from '../ApiClient'

/**
 * useApiStore – wrapper around the ApiClient to add on an error handler
 *
 * @returns {Object}  The store
 */
export const useApiStore = create(set => {
  const api = new ApiClient(() => {}, { enableSocket: false })

  return {
    api,
    setErrorHandler: handler =>
      set(state => {
        state.api.onError = handler
        return { api: state.api }
      }),
  }
})
